import React, { useMemo } from "react";
import dynamic from "next/dynamic";
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"),{ssr: true});
import styles from "./style.module.scss";
import { getArticleUrl } from "@/utils/common";
const BlogCards = dynamic(() => import("./BlogCard"),{ssr: true});

type ActionCardProps = {
  block: any;
};

const BuildSection: React.FC<ActionCardProps> = ({ block }) => {
  const titleClassName = "max-w-[1230px]";
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  // Build the class name once so SSR and CSR match exactly
  const sectionClassName = useMemo(
    () => `${styles.sectionWrapper} xl:py-[100px] md:py-[95px] py-[56px]`,
    [],
  );

  const data = block;

  return (
    <Section className={sectionClassName}>
      <div className={styles.gradientOverlay}>
        <div className={styles.innerGradient} />
      </div>

      <div className="container text-center">
        <h2
          className={`mx-auto font-bold text-primary-text text-heading-1 ${titleClassName}`}
        >
          {data?.header?.label ?? ""}
        </h2>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 lg:mt-10 mt-8">
          {data?.articles?.data?.map((card: any, index: number) => {
            const slug = card?.attributes?.slug?.startsWith("/")
              ? card?.attributes?.slug
              : getArticleUrl(card);

            return (
              <BlogCards
                key={index}
                label="Read More"
                link={slug}
                title={card?.attributes?.title}
                details=""
                classname="lg:h-auto h-full md:min-h-[458px] min-h-[458px]"
                imageUrl={`${baseUrl}${card?.attributes?.image?.data?.attributes?.url}`}
              />
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export default BuildSection;
